import useAuth from '../../auth/authContext';
import { facebookConfig } from '../../commons/config';

export const useIsFacebookEnabled = () => {
  const {
    state: { user },
  } = useAuth();
  const isFacebookEnabled =
    facebookConfig.enabled &&
    !!user &&
    (facebookConfig.restrictedDomainsOnly.length === 0 ||
      !!(
        user.email &&
        facebookConfig.restrictedDomainsOnly.some((d) =>
          user.email.toLowerCase().endsWith(`@${d.toLowerCase()}`)
        )
      ));
  return { isFacebookEnabled };
};
